import { render, staticRenderFns } from "./RefundProductCard.vue?vue&type=template&id=989b5e5e&"
import script from "./RefundProductCard.vue?vue&type=script&lang=js&"
export * from "./RefundProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports